import { IDropdownOption } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import {
    createProductFilterModel, ProductFilterModel, ProductKeyModel, ShortLineModel
} from "../models/ProductModel";
import { ProductUtils } from "../ProductUtils";
import { AdminProductLineService } from "../services/AdminProductLineService";

export default function useAdminProductVM() {
    const service = new AdminProductLineService();

    const [lines, setLines] = useState<ShortLineModel[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<ProductKeyModel | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [listHash, setListHash] = useState(Utils.getRandomKey());
    const [pageHash, setPageHash] = useState<number>(Utils.getRandomKey());

    const [barcode, setBarcode] = useState("");

    const [loading, setLoading] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [showAddOneTime, setShowAddOneTime] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showBarcode, setShowBarcode] = useState(false);
    const [showScript, setShowScript] = useState(false);

    const [brandOptions, setBrandOptions] = useState<IDropdownOption[]>([]);
    const [sizeOptions, setSizeOptions] = useState<IDropdownOption[]>([]);

    const {
        form: filter,
        setForm: setFilter,
        resetForm: resetFilter,
        setField: setFilterField
    } = useForm<ProductFilterModel>(createProductFilterModel());

    const {
        form: tempFilter,
        setForm: tempSetFilter,
        resetForm: tempResetFilter,
        setField: tempSetFilterField
    } = useForm<ProductFilterModel>(createProductFilterModel());

    const onLoad = () => {
        getList();
        ProductUtils.getBrandOptions((list: IDropdownOption[]) => setBrandOptions(list));
        ProductUtils.getSizeOptions((list: IDropdownOption[]) => setSizeOptions(list));
    }

    const getList = (pageChange = false) => {
        getListWithFilter(filter, pageChange);
    }

    const getListWithFilter = (newFilter: ProductFilterModel, pageChange = false) => {
        setFilter(newFilter);

        setLoading(true);
        setListHash(Utils.getRandomKey());
        setLines([]);

        const request = service.search(newFilter);

        DataUtils.onRequest(
            request,
            (result: IDataResult) => getListResult(result, pageChange)
        );
    }

    const getListResult = (result: IDataResult, pageChange = false) => {
        if (result.status === ResponseStatus.success) {
            setLines(result.data.items);
            setTotalCount(result.data.totalCount);
            setListHash(Utils.getRandomKey());

            if (!pageChange) {
                setPageHash(Utils.getRandomKey());
            }
        }

        setLoading(false);
    }

    return {
        lines, setLines,
        selectedProduct, setSelectedProduct,
        totalCount,
        listHash,
        pageHash,
        barcode, setBarcode,

        loading, setLoading,
        showFilter, setShowFilter,
        showAdd, setShowAdd,
        showAddOneTime, setShowAddOneTime,
        showDetail, setShowDetail,
        showBarcode, setShowBarcode,
        showScript, setShowScript,

        brandOptions,
        sizeOptions,

        filter, setFilter, resetFilter, setFilterField,
        tempFilter, tempSetFilter, tempResetFilter, tempSetFilterField,

        onLoad,
        getList,
        getListWithFilter
    }
}